module.exports = __webpack_public_path__ + "static/media/view_reports.f550eb05.svg";